import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import { formatDuration } from "@/i18n/format";

/** Seconds since `startedAt` (an ISO time), updated every second; never negative, even with a skewed clock. */
function useSecondsSince(startedAt: string) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  const start = Date.parse(startedAt);
  return Number.isNaN(start) ? 0 : Math.max(0, (now - start) / 1000);
}

/** How long a research run has been going ("2m 5s elapsed"). Kept out of the stage's live region. */
export function Elapsed({ startedAt }: Readonly<{ startedAt: string }>) {
  const { t } = useTranslation("chat", { keyPrefix: "research.progress" });
  const seconds = useSecondsSince(startedAt);
  return (
    <Text as="span" variant="caption" tone="tertiary" className="shrink-0">
      {t("elapsed", { time: formatDuration(Math.floor(seconds)) })}
    </Text>
  );
}
